import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-details',
  templateUrl: './track-details.component.html',
  styleUrls: ['./track-details.component.scss']
})
export class TrackDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
